import { axiosInstance } from "@/services/axiosInstance";
import { CreditPromoter } from "src/models/creditPromoter.model";

export const createCreditPromoter = async (
  creditPromoterData: Partial<CreditPromoter>
): Promise<CreditPromoter> => {
  const response = await axiosInstance.post(
    "/api/credit-promoter",
    creditPromoterData
  );
  return response.data;
};

export const updateCreditPromoter = async (
  id: number,
  creditPromoterData: CreditPromoter
): Promise<Response> => {

  const response = await axiosInstance.put(
    `/api/credit-promoter/${id}`,
    creditPromoterData
  );
  return response.data;
};

export const getCreditPromoters = async (
  page: number,
  pageSize: number,
  search: string
): Promise<{ data: CreditPromoter[]; totalPages: number }> => {
  const response = await axiosInstance.get(
    `/api/credit-promoter`, {
    params: {
      page,
      pageSize,
      search
    }
  }
  );

  return {
    data: response.data.data,
    totalPages: response.data.totalPages,
  }
};



export const getCreditPromoterById = async (creditPromoterId: any): Promise<CreditPromoter | null> => {
  if (!creditPromoterId) return null;
  try {
    // console.log('Fetching credit promoter with ID:', creditPromoterId);

    const response = await axiosInstance.get(
      `/api/credit-promoter/${creditPromoterId}`
    );
    return response.data.data;
  }
  catch (error) {
    console.error("Error getting credit promoter:", error);
    throw error;
  }
}
